import React from "react";
import { Helmet } from "react-helmet";

export const Page404 = () => {
  return (
    <div className={"p-2 p-lg-5"}>
      <Helmet>
        <title>Minha Glambox : Ops! Página não encontrada!</title>
      </Helmet>
      
      <h1>404 : Página não encontrada</h1>
      
      <div className={"gb-contentblock level-2 p-2 p-lg-5"}>
        <p>Ops! Página não encontrada!</p>
      </div>
    </div>
  );
};
